import { StatusTag, type StatusTagTone } from '../../../components/StatusTag';
import { useT } from '../../../locales';
import type { ResultadoVisita } from '@aid/shared';

const TONE: Record<ResultadoVisita, StatusTagTone> = {
  NO_ENCONTRADO: 'warning',
  VOLVERA: 'info',
  DEPOSITARA: 'info',
  PAGO: 'success',
  OTRO: 'neutral',
};

export function VisitaResultadoTag({ resultado }: { resultado: ResultadoVisita }) {
  const t = useT();
  return <StatusTag tone={TONE[resultado]}>{t(`pages.visitas.resultados.${resultado}`)}</StatusTag>;
}
